import { useContext } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";

import { getTaxCafNumber } from "../../selectors";
import { CompanyContext } from "../CompanyList/CompanyContext";

export const BaseCafNumber = ({ className }) => {
	const { company } = useContext(CompanyContext);
	const cafNumber = useSelector((state) => getTaxCafNumber(state, { company }));

	if (!cafNumber) return null;

	return <span className={className}>IRS CAF #: {cafNumber}</span>;
};

BaseCafNumber.propTypes = {
	className: PropTypes.string,
};
